import { matchesMeetingTemplate } from '@confluence/experiment-meeting-signal-core/entry-points/matchesMeetingTemplate.ts';
import { matchMeetingSignal } from '@confluence/experiment-meeting-signal-core/entry-points/matchMeetingSignal.ts';

import { MEETING_NOTES_TITLE_KEYWORDS } from './meetingNotesKeywords.ts';

export type MeetingNotesSignalInput = {
	title?: string | null;
	/**
	 * Ignored. The signal no longer looks at body text.
	 *
	 * Still accepted so existing callers keep compiling; the parameter and the
	 * plumbing that feeds it are removed in a follow-up, which also drops the
	 * page body from the Relay fragment.
	 */
	content?: string;
	sourceTemplateEntityId: string;
};

export type MeetingNotesMatch = {
	matches: boolean;
	matchedTitle: boolean;
	matchedTemplate: boolean;
};

/**
 * Pure, synchronous meeting-notes signal match against a page's title and source
 * template.
 *
 * Body text is deliberately not considered. Matching keywords against the page
 * body fired on far too many pages, because the content keywords are common
 * words that appear incidentally in ordinary documents. Both remaining signals
 * are narrow: the title is short and deliberately chosen, and the template
 * signal compares against known Confluence meeting template ids.
 */
export const matchesMeetingNotesSignal = ({
	title,
	sourceTemplateEntityId,
}: MeetingNotesSignalInput): MeetingNotesMatch => {
	const matchedTitle = !!title && matchMeetingSignal(title, MEETING_NOTES_TITLE_KEYWORDS);
	const matchedTemplate =
		!!sourceTemplateEntityId &&
		matchesMeetingTemplate({ idType: 'other', id: sourceTemplateEntityId });

	return {
		matches: matchedTitle || matchedTemplate,
		matchedTitle,
		matchedTemplate,
	};
};
